import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const referralCode = localStorage.getItem("pickem_referral_code") || undefined;
        const { data } = await api.post("/auth/session", { session_id: sessionId, referral_code: referralCode });
        if (referralCode) localStorage.removeItem("pickem_referral_code");
        setUser(data.user);
        const invite = localStorage.getItem("pickem_invite_code");
        if (invite) {
          localStorage.removeItem("pickem_invite_code");
          window.history.replaceState({}, document.title, `/join/${invite}`);
          toast.success(`Welcome, ${data.user.name}! Here's your invite.`);
          navigate(`/join/${invite}`, { replace: true, state: { user: data.user } });
          return;
        }
        // clear hash
        window.history.replaceState({}, document.title, "/lobby");
        toast.success(`Welcome, ${data.user.name}!`);
        navigate("/lobby", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Sign in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white/60">
      <div className="font-display text-3xl tracking-widest animate-pulse">SIGNING IN...</div>
    </div>
  );
}
